import { Permissao } from './../../../_core/models/permissao';
import { PermissaoService } from './../../../_core/services/permissao.service';
import { HistoricoBensModalComponent } from './../historico-bens-modal/historico-bens-modal.component';
import { CadastroBemService } from './../../../_core/services/cadastro-bem.service';
import { LoginService } from 'src/app/_core/services/login.service';
import { CadastroBem } from 'src/app/_core/models/cadastro-bem';
import { DOCUMENT, formatDate } from '@angular/common';
import { MovimentacaoService } from './../../../_core/services/movimentacao.service';
import { PageService } from 'src/app/_core/services/page.service';
import { Usuario } from 'src/app/_core/models/usuario';
import { Page } from 'src/app/_core/models/page';
import { Movimentacao } from './../../../_core/models/movimentacao';
import { Component, OnInit, Inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-historico-bens',
  templateUrl: './historico-bens.component.html',
  styleUrls: ['./historico-bens.component.scss']
})
export class HistoricoBensComponent implements OnInit {
  pagina = 1;
  total = 10;
  page!: Page;
  ativo = true;
  pesquisa = '';
  loading = true;
  movimentacao: Movimentacao[] = [];
  mov!: Movimentacao;
  bens!: CadastroBem[];
  user: Usuario;
  keywordBens = 'dS_BPM_DESCRICAO_BEM'
  nR_BPM_BEM_PATRIMONIAL: number;
  permissao: Permissao[];

  constructor(
    private pageService: PageService,
    private movimentacaoService: MovimentacaoService,
    private loginService: LoginService,
    private cadastroBemService: CadastroBemService,
    private modalService: NgbModal,
    private permissaoService: PermissaoService,
    @Inject(DOCUMENT) private document: Document) {
    this.ativo = true;
    this.page = new Page();
    this.page.currentPage = this.pagina;
    this.page.pageSize = this.total;
    this.page.ativo = this.ativo;
    this.page.currentPage = 1;
  }

  ngOnInit() {
    this.nR_BPM_BEM_PATRIMONIAL = 0;
    // this.setPage(this.page.currentPage);
    this.user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.getBensAll();
    this.loading = false;
  }
  getBensAll() {
    this.permissaoService.getBy_SiglaMatricula('PATRIMONIO', this.user.cD_MATRICULA).subscribe(
      data => {
        //console.log/"", data);
        this.permissao = data;
        // this.permissao.filter(index =>{
        //   return index.toString().indexOf('admin');
        // })
        // let index = this.permissao.findIndex(x => x.DS_PERFIL_ACESSO == 'contabilidade[EPATRIMONIO]')
        let index = this.permissao.map(function (e) { return e.DS_PERFIL_ACESSO.indexOf('admin'); });
        //console.log/"Cargo " + index);
        if (index[0] == 0) {
          //console.log/"ADMIN");
          return this.cadastroBemService.listarMatById(this.user.cD_MATRICULA)
            .subscribe(
              data => {
                this.bens = data;
                this.bens.map(data => data.dS_BPM_DESCRICAO_BEM = ` ${data.dS_BPM_ETIQUETA_BEM} | ${data.dS_BPM_DESCRICAO_BEM} `);
              }
            )
        } else{
          //console.log/"NÃO É ADMIN");
           return this.cadastroBemService.listarMatById(this.user.cD_MATRICULA)
            .subscribe(data => {
              this.bens = data;
              this.bens.map(data => data.dS_BPM_DESCRICAO_BEM = ` ${data.nR_BPM_BEM_PATRIMONIAL} | ${data.dS_BPM_DESCRICAO_BEM} `);
            });
        }

      }
    )

  };
  selectBem(item: any) {
    this.nR_BPM_BEM_PATRIMONIAL = Number(item.nR_BPM_BEM_PATRIMONIAL);
    this.atualizar();

  };
  refresh() {
    this.document.location.reload();
  };
  getMovAll() {
    this.movimentacaoService.mov_getAll()
      .subscribe(
        data => {
          this.movimentacao = data;
        }
      )
  };
  setPage(page: number) {
    this.loading = true;
    this.page.currentPage = page;
    // this.page.dataInicio = this.inicio;
    // this.page.dataFim = this.fim;
    this.movimentacaoService.mov_listarHistorico(this.nR_BPM_BEM_PATRIMONIAL, this.page)
      .subscribe(
        data => {
          this.page = data;
          this.page = this.pageService.getPager(this.page);
          this.loading = false;
        },
        err => {
          this.loading = false;
        }
      )
  }
  paginaAtual(pagina: any) {
    return this.page.currentPage === pagina;
  }
  pesquisar() {
    this.page.pesquisa = this.pesquisa;
    this.page.ativo = this.ativo;
    // this.page.dataInicio = this.inicio
    // this.page.dataFim = this.fim;
    this.page.dados = [];
    this.setPage(1);
  }
  ativar() {
    // this.page.dataInicio = this.inicio;
    // this.page.dataFim = this.fim;
    this.ngOnInit();
  }
  atualizar() {
    this.pesquisa = '';
    // this.page.dataInicio = this.inicio;
    // this.page.dataFim = this.fim;
    this.page.totalItems = this.page.pageSize
    this.ativo = true;
    this.page.dados = [];
    this.pesquisar();
  }
  abreEdicao(nR_BPM_BEM_PATRIMONIAL: number, cD_BPM_MOVIMENTACAO_PATRIMONIAL: number, cD_BPM_MOVIMENTACAO_PATRIMONIAL_FIM: number) {
    const modalRef = this.modalService.open(
      HistoricoBensModalComponent, {
      size: 'xl',
      backdrop: 'static',
    });
    modalRef.componentInstance.nR_BPM_BEM_PATRIMONIAL = nR_BPM_BEM_PATRIMONIAL;
    modalRef.componentInstance.cD_BPM_MOVIMENTACAO_PATRIMONIAL = cD_BPM_MOVIMENTACAO_PATRIMONIAL;
    modalRef.componentInstance.cD_BPM_MOVIMENTACAO_PATRIMONIAL_FIM = cD_BPM_MOVIMENTACAO_PATRIMONIAL_FIM;
    
  }
}
